import React from 'react'

import NextImage from '@/library/blocks/images/NextImage';
import MomentFormatter from '@/library/utils/formatters/MomentFormatter';
import Bookmark from '@/library/entities/socialize/bookmark/Bookmark';
import Pill from '@/library/blocks/pills/Pill';
import Link from 'next/link';
import { Route } from '@/routers/routes';

export default function ECListItemSmall(props) {
  const { item, className = '', showInstrument = false, roundedImage = false, showPreamble = true } = props
  const href = Route.insightDetail(item)
  const instrumentHref = Route.instrumentDetail({ slug: item.instrument_slug, country_id: item.country_id })
  return (
    <article className={`_ECListItemSmall ${className} grid grid-cols-6 sm:grid-cols-5 gap-2 px-4`} key={item.pk}>
      <div className='col-span-2 sm:col-span-2'>
        <Link href={href} className="">
          <NextImage
            src={item.image_main_url}
            alt={item.image_main_alt}
            width={198}
            height={144}
            className={`w-full h-full object-cover ${roundedImage ? 'rounded-xl' : ''}`}
          />
        </Link>
      </div>
      <div className='col-span-4 sm:col-span-3 flex flex-col gap-2'>
        <Link href={href} className="flex flex-col gap-2">
          <h3 className='text-md font-medium text-zink-200'>{item.title}</h3>
          {showPreamble && <p className='text-sm text-zink-200 line-clamp-2 '>{item.preamble}</p>}
          <p className="text-xs text-gray-600">
            <MomentFormatter date={item.published_at} />
          </p>
        </Link>
        {showInstrument && (
          <Pill href={instrumentHref} size='xs' className='w-fit'>{item.instrument_name}</Pill>
        )}
        <Bookmark className='' countPlacement='right' appName='publications' modelName='editorialcontent' entityId={item.pk} />
      </div>
    </article>
  )
}
